import type { ClientRouteOptionsType } from 'nuxt-base/utils/documentLinks'
import type { RouteLocationRaw, RouteLocationNamedRaw, RouteLocationGeneric } from '#vue-router'

export default defineNuxtPlugin(() => {
  const clientRoutesSeller = {
    CART: 'cart',
    INFO: 'info',
    HOMEPAGE: 'index',
    LOGIN: 'auth',
    SEARCH: 'search',
    SIGNUP: 'auth',
    USER_ORDERS: 'user-orders',
    USER_SETTINGS: 'user-profile',
    BRANDS: 'brands',
    INFO_ABOUT_US: 'info-about',
    INFO_CERTIFICATES: 'info-certificates',
    INFO_DELIVERY: 'info-delivery',
    INFO_FABRICS: 'info-fabrics',
    INFO_FACTORIES: 'info-factory',
    INFO_FAQ: 'info-faq',
    RETURN_FORM: 'info-returns',
    INFO_RETURNS: 'info-returns',
    INFO_SHOPS: 'info-shops',
    INFO_PRODUCT_CARE: 'info-care',
    INFO_WARRANTY: 'info-warranty',
    PRIVACY_POLICY: 'info-privacy-policy',
    COOKIE_POLICY: 'info-cookie-policy',
    TERMS_AND_CONDITIONS: 'info-terms-and-conditions',
  } satisfies Record<ClientRouteOptionsType, string>

  const locale = useLocale()
  const { rewrite, router } = useI18nRouteRewrite()

  function myLink(name: string, params?: RouteLocationNamedRaw['params'], query?: Record<string, string | None | undefined | string[]>): RouteLocationGeneric {
    return rewrite({ name, params, query }, locale.value)
  }

  const linkCookiePolicy = () => myLink('info-cookie-policy', {})
  const linkTerms = () => myLink('info-terms-and-conditions', {})
  const linkPrivacy = () => myLink('info-privacy-policy', {})
  const linkUpcoming = (id: string) => myLink('user-upcoming-id', { id })
  const linkOrder = (id: string) => myLink('user-orders-id', { id })
  const linkPayment = (id: string) => myLink('user-orders-id', { id })

  function linkSellerLink(link: Omit<gen.InputSellerLink, 'alt'> | None): RouteLocationRaw | string | undefined {
    const type = link?.type
    const slug = link?.slug
    // const seller = link?.sellerId

    if (!type || !slug) return

    switch (type) {
      case 'GlobalClient': {
        const to = helpers.getEnumValue(clientRoutesSeller, slug)
        return to ? myLink(to) : undefined
      }
      case 'Outside': {
        if (slug.startsWith('https')) return slug
        return
      }
      case 'SellerClient': {
        // return myLink('@seller', { seller })
        return myLink('index', {})
      }
      case 'SellerListing': {
        // return myLink('@seller-p-slug', { seller, slug })
        return myLink('p-slug', { slug })
      }
      case 'GlobalDepartment': {
        // return myLink('@seller-s-all', { all: ['d', slug], seller })
        return myLink('search-all', { all: ['d', slug] })
      }
      case 'CatalogUi': {
        // return myLink('@seller-s-all', { all: ['c', slug], seller })
        return myLink('search-all', { all: [slug] })
      }
      case 'Article': {
        // return myLink('@seller-editorial-slug', { slug, seller })
        return myLink('editorial-slug', { slug })
      }
      case 'Faq': {
        // return myLink('@seller-info-slug', { slug, seller })
        return myLink('info-slug', { slug })
      }
      case 'Profile': {
        // return myLink('i-handle', { handle: slug })
        return myLink('index', {})
      }
      case 'SizeGuide': {
        // return myLink('@seller-info-size-guide', { seller }, { guide: slug })
        // return myLink('info-size-guide', {}, { guide: slug })
        // return myLink('info-size-guide', {}, { guide: slug })
        return myLink('index', {})
      }
      default:
    }
  }

  function toFullUrl(to: Parameters<typeof router.resolve>[0] | RouteLocationGeneric) {
    if (typeof to === 'object' && to && 'fullPath' in to && typeof to.fullPath === 'string') {
      return toFullUrlAdd(to.fullPath)
    }
    return toFullUrlAdd(router.resolve(to).fullPath)
  }

  const route = useRoute()

  return {
    provide: {
      links: {
        rewrite,
        currentFullUrl: computed(() => toFullUrlAdd(route.fullPath)),
        toFullUrl,
        myLink,
        linkProduct: (i: { slug: string; privateVisibility?: None | boolean }) => {
          return i?.slug ? myLink(i.privateVisibility ? 'b2b-p-slug' : 'p-slug', { slug: i.slug }) : undefined
        },
        linkCookiePolicy,
        linkTerms,
        linkPrivacy,
        linkUpcoming,
        linkOrder,
        linkPayment,
        linkSellerLink,
        // product(input: None | { slug?: string | None }): RouteLocationRaw | undefined {
        //   const slug = input?.slug
        //   if (!slug) return
        //   // const seller = sellerId.value
        //   // return seller ? myLink('@seller-p-slug', { seller, slug }) :
        //   return myLink('p-slug', { slug })
        // },

        article(slug: string, _?: string | None): RouteLocationRaw | undefined {
          // slug: string, sellerHandler?: string | None
          // const seller = sellerId.value || sellerHandle
          if (!slug) return
          // if (seller) return myLink('@seller-editorial-slug', { slug, seller })
          // return myLink('editorial-slug', { slug })
          return myLink('index', { slug })
        },
      },
    },
  }
})
